import { useNavigate } from "react-router-dom";
import { ForgotPasswordContainer } from "../components/ForgotPassword/ForgotPasswordContainer";

type Props = {
  onError?: () => void;
};

export function ForgotPasswordPage({ onError }: Props) {
  const navigate = useNavigate();

  const onCancel = () => {
    navigate("/login");
  };

  return <ForgotPasswordContainer onCancel={onCancel} onError={onError} />;
}

export default ForgotPasswordPage;
